import React from 'react';
import {
  Button,
  Checkbox,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const SelectionActionBar = ({
  selectedCount,
  pageCount,
  allOnPageSelected,
  someOnPageSelected,
  onTogglePage,
  onClear,
  children,
}) => {
  if (!selectedCount) return null;
  return (
    <Paper
      variant="outlined"
      role="region"
      aria-label="Selection actions"
      sx={{
        position: 'sticky',
        top: { xs: 64, md: 8 },
        zIndex: 7,
        px: 1.5,
        py: 1,
        borderColor: 'primary.main',
        bgcolor: 'var(--md-sys-color-primary-container)',
      }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="space-between" alignItems={{ sm: 'center' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Checkbox
            checked={allOnPageSelected}
            indeterminate={someOnPageSelected && !allOnPageSelected}
            onChange={onTogglePage}
            inputProps={{ 'aria-label': allOnPageSelected ? 'Deselect this page' : 'Select this page' }}
          />
          <Typography variant="body2" role="status" aria-live="polite">
            {selectedCount.toLocaleString()} selected{pageCount ? ` · ${pageCount.toLocaleString()} on this page` : ''}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {children}
          <Button color="inherit" startIcon={<ClearIcon />} onClick={onClear}>Clear</Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default SelectionActionBar;
